import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Pilots() {
  const { id } = useParams();

  return (
    <div>
      <Header />
      <main><h1>Detalhes do Piloto {id}</h1></main>
      <Footer />
    </div>
  );
}

export default Pilots;